<div mat-dialog-title>
  <p8-layout-settings-header [titlePath]="titlePath()"></p8-layout-settings-header>
</div>

<div class="p8-cm_dialog-validation__body mat-typography">
  <span *ngIf="iconPrefix" [innerHTML]="iconPrefix | safeHtml"></span>
  <div *ngIf="data.transition === stateTransitionToGo.demande_refusee">
    <p *ngIf="!data.dossier.observations_commission"><mat-icon>warning</mat-icon> Il n'y a pas d'observations <mat-icon>warning</mat-icon></p>
    <fieldset *ngIf="data.dossier.observations_commission">
      <legend>Observations commission</legend>
      <span [innerHTML]="data.dossier.observations_commission | newline | safeHtml"></span>
    </fieldset>
  </div>
  <span *ngIf="dialogData?.message" [innerHTML]="dialogData.message | safeHtml"></span>
</div>

<div *ngIf="recruteForm && data && data.recrute.hasRecrute">
  <mat-card>
    <mat-card-subtitle>INM recruté et optionnellement, vous pouvez saisir le recruté <span *ngIf="data.recrute.hasSptaGestionnaire">et le gestionnaire SPTA</span></mat-card-subtitle>
    <mat-card-content>
      <app-recrute
        [recrute]="recruteForm"
        (onRecruted)="onChangeRecrut($event)"
        [displayGestSPTA]="data.recrute.hasSptaGestionnaire"></app-recrute>
    </mat-card-content>
  </mat-card>
</div>

<div *ngIf="data.recrute.hasDatePriseFonction">
  <mat-card>
    <mat-card-title>Date de prise de fonction de l'agent <strong class="mandatory-field">*</strong></mat-card-title>
    <mat-card-content>
      <mat-form-field>
        <input matInput
               [(ngModel)]="datePriseFonction"
               [matDatepickerFilter]="dateSvc.filterWE"
               [matDatepicker]="date_fin" placeholder="Date de prise de fonction *">
        <mat-datepicker-toggle matSuffix [for]="date_fin"></mat-datepicker-toggle>
        <mat-datepicker #date_fin></mat-datepicker>
      </mat-form-field>
    </mat-card-content>
  </mat-card>
</div>
<mat-dialog-actions fxLayoutAlign="end">
  <button mat-button
          [matDialogClose]="false">NON</button>

  <button mat-button
          [color]="'warn'"
          [matDialogClose]="true"
          [disabled]="saveIsDisabled()"
          (click)="validate()">OUI</button>
</mat-dialog-actions>
